import { isNative } from "./platform";

/** Applies status bar style/background. Defaults to light content theme. */
export async function applyStatusBarTheme(dark = false): Promise<void> {
  if (!isNative()) return;
  const { StatusBar, Style } = await import("@capacitor/status-bar");
  await StatusBar.setStyle({ style: dark ? Style.Dark : Style.Light });
}
